import React from 'react';
import { IconsPros } from '../icons/types';

/**
 * Marketo Logo component
 *
 * @returns JSX.ELEMENT
 */
export const MarketoLogo = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 86.31 57.41" data-testid={dataTestId}>
      <path
        fill="#8d6fc9"
        d="M40,25.92h-8.7a5.09,5.09,0,0,0-4.71,3.73l-4.22,18c5.77.33,11.1.85,16,1.54L43,29.65a2.91,2.91,0,0,0-3-3.73M17.25,35.85H8.55a5.09,5.09,0,0,0-4.71,3.73L2,47.48c1.36-.1,2.75-.17,4.24-.19q6.36-.06,12.15.16l1.85-7.87a2.91,2.91,0,0,0-3-3.73M61.58,17.37H52.89a5.09,5.09,0,0,0-4.72,3.73L41.48,49.65A142.94,142.94,0,0,1,57.09,53L64.55,21.1a2.91,2.91,0,0,0-3-3.73M85.23,2.42H76.54a5.07,5.07,0,0,0-4.72,3.72L60.61,54a98.9,98.9,0,0,1,15,5.85L88.2,6.14a2.91,2.91,0,0,0-3-3.72"
        transform="translate(-1.98 -2.42)"
      />
    </svg>
  );
};
